import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.settings.CompanySettingsView.hint.p1")}</h3>
    <p>{I18n.t("papp.settings.CompanySettingsView.hint.p2")}</p>

    <h3>{I18n.t("papp.settings.CompanySettingsView.hint.p3")}</h3>
    <p>{I18n.t("papp.settings.CompanySettingsView.hint.p4")}</p>

    <h3>{I18n.t("papp.settings.CompanySettingsView.hint.p5")}</h3>
    <p>{I18n.t("papp.settings.CompanySettingsView.hint.p6")}</p>

    <h3>{I18n.t("papp.settings.CompanySettingsView.hint.p7")}</h3>
    <p>{I18n.t("papp.settings.CompanySettingsView.hint.p8")}</p>

    <h3>{I18n.t("papp.settings.CompanySettingsView.hint.p9")}</h3>
    <p>{I18n.t("papp.settings.CompanySettingsView.hint.p10")}</p>

    <h3>{I18n.t("papp.settings.CompanySettingsView.hint.p11")}</h3>
    <p>{I18n.t("papp.settings.CompanySettingsView.hint.p12")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/settings/CompanySettingsView/CompanySettingsHint.jsx